<template>
  <div>
    <div
      v-if="showNewRequest"
      class="text-left"
    >
      <naj-button
        type="button"
        size="small"
        @click="openModal"
      >
        <v-icon
          right
          v-text="`mdi-plus`"
        ></v-icon>
        {{ local.home.tabCommon.newRequest }}
      </naj-button>
    </div>
    <v-row class="mx-12">
      <template>
        <v-col
          v-for="(subRequest, index) in requests"
          :key="index"
          cols="4"
        >
          <bankruptcy-card
            :info-item="subRequest"
            :icon="'mdi-archive'"
            :header="`${local.bankruptcy.bankruptcyFile.request} ${subRequest.requestTypeName}`"
            :code-display-name="local.caseFile.cards.request.codeDisplayName"
            :code="subRequest.subRequestCode"
            :status=" subRequest.requestStatusName"
            :status-display-name="local.caseFile.cards.request.statusDisplayName"
            :date="subRequest.requestDate"
            :date-display-name="local.caseFile.cards.request.dateDisplayName"
            :has-actions="true"
            :court-name="subRequest.courtName"
            :sub-circle-name="subRequest.subCircleName"
          >
            <template
              slot="actions"
              slot-scope="{}"
            >
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-icon
                    large
                    v-on="on"
                  >
                    mdi-dots-vertical
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item>
                    <v-list-item-title>
                      <router-link :to="`/bankruptcy/${subRequest.mainRequestObjectKey}/bankruptcy-file/sub-request/view-sub-request/${subRequestTypeIds[subRequest.requestTypeId]}/${subRequest.objectKey}`">
                        <naj-button
                          text
                          type="button"
                          size="small"
                        >
                          {{ local.common.show }}
                        </naj-button>
                      </router-link>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </bankruptcy-card>
        </v-col>
      </template>
      <v-col cols="12">
        <naj-no-data
          :has-data="requests && requests.length > 0"
          :loading="loading"
        ></naj-no-data>
      </v-col>
    </v-row>
    <naj-confirmation
      :show-modal="showRequestModel"
      :max-width="771"
      :title="local.home.tabCommon.newSubRequest"
      :show-close-btn="false"
      @cancel="() => {
        selectedRequestType = {};
        selectedRequestTypeId = 0;
        showRequestFullExplanation = false;
        showRequestModel = false;
        pledged = false;
      }"
    >
      <template slot="message-content">
        <span class="explanation">
          {{ local.bankruptcy.subRequests.newSubRequestExplanation }}
        </span>
        <v-row>
          <v-col cols="12">
            <naj-input
              :type-id="formFieldType.selectbox"
              :label="local.bankruptcy.bankruptcyFile.requests.requestName"
              :value.sync="selectedRequestTypeId"
              :items="subRequestTypes"
              item-text="name"
              item-value="id"
              :disabled="true"
            ></naj-input>
          </v-col>
          <v-col
            v-if="showRequestFullExplanation"
            cols="12"
          >
            <naj-alert type="alert">
              <template slot="content">
                {{ local.lawsuitDetails.caseRelatedRequestFeesNote }}
                <a
                  :href="Urls.judicialFees"
                  target="_blank"
                  class="about-link"
                >
                  {{ local.common.clickHere }}
                </a>
              </template>
            </naj-alert>
          </v-col>
          <v-col
            v-if="showRequestFullExplanation"
            cols="12"
          >
            <naj-input
              :type-id="formFieldType.checkbox"
              :value.sync="pledged"
              :label="selectedRequestType.fullExplanation"
            ></naj-input>
          </v-col>
        </v-row>
      </template>

      <template slot="actions">
        <naj-button
          :disabled="!pledged"
          @click="openCreateNewRequest()"
        >
          {{ local.common.saveAndSend }}
        </naj-button>
      </template>
    </naj-confirmation>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('BankruptcyModule');
import BankruptcyCard from '@/modules/bankruptcy/components/bankruptcy-file/bankruptcy-card.vue';
import { subRequestTypeIds, subRequestTypesEnum, subRequestType, subRequestStatus } from '@/modules/bankruptcy/helpers/enum';
const { mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');
import { userType } from '@/helpers/enum';
import { Urls } from '@/modules/judicialFees/helpers/enum';

export default {
  name: 'RequestsTab',
  components: { BankruptcyCard },
  props: {
    requestInfo: {
      type: Object,
      required: true,
    },
    showNewRequest: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      loading: false,
      requests: [],
      subRequestTypeIds,
      subRequestTypesEnum,
      showRequestFullExplanation: false,
      pledged: false,
      selectedRequestType: {},
      subRequestType,
      userType,
      subRequestTypes: [],
      selectedRequestTypeId: 0,
      Urls,
      showRequestModel: false,
      subRequestStatus,
    };
  },
  computed: {
    ...mapGlobalState(['userInfo']),
    isRequestOwner() {
      return this.requestInfo.mainRequest.isRequestOwner;
    },

  },
  watch: {},
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions(['getRequestsBySubRequestObjectKey', 'canIssueSubRequest', 'getValidSubRequestsForProcedure']),
    loadData() {
      this.loading = true;
      let payload = {
        objectKey: this.requestInfo.mainRequestObjectKey,
        identityNumber: this.userInfo.socialId,
        unifiedNumber: this.userInfo.socialId,
        isSubRequest: true,
      };
      Promise.all([
        this.getRequestsBySubRequestObjectKey(this.requestInfo.objectKey),
        this.getValidSubRequestsForProcedure(payload),
      ]).then((res) => {
        this.requests = res[0].data;
        this.subRequestTypes = res[1].data.filter(rt => rt.id == subRequestType.VerdictObjectionRequest);
      })
        .finally(() => {
          this.loading = false;
        });
    },
    openModal() {
      this.showRequestModel = true;
      this.selectedRequestType = {};
      this.showRequestFullExplanation = false;
      this.pledged = false;

      this.selectedRequestTypeId = this.subRequestType.VerdictObjectionRequest;
      const requestType = this.subRequestTypes.find(rt => rt.id == subRequestType.VerdictObjectionRequest);
      if (typeof requestType === 'undefined' || requestType === null || this.requestType === '')
        return;
      const params = {
        objectKey: this.requestInfo.mainRequestObjectKey,
        requestType: requestType.code,
        subRequestObjectKey: this.requestInfo.objectKey,
        isInternal: true,
      };
      this.canIssueSubRequest(params)
        .then((res) => {
          if (res.data) {
            this.showRequestFullExplanation = true;
            this.selectedRequestType = requestType;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onModalClose() {
      this.markerPoint = { ...this.selectedPoint };
    },
    openCreateNewRequest() {
      this.showRequestFullExplanation = false;
      this.$router.push({ path: `/bankruptcy/${this.requestInfo.mainRequestObjectKey}/bankruptcy-file/sub-request/VerdictObjectionRequest/${this.requestInfo.objectKey}` });
    },
  },
};

</script>

<style lang="scss" scoped>
.explanation {
  font-size: 18px;
  font-weight: bold;
}
</style>
